import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index'
import Question from '@/page/Question'
import Report from '@/page/Report'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Index
    },
    {
      path: '/question',
      name: '问答',
      component: Question
    },
    {
      path: '/report',
      name: '报告',
      component: Report
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js